<template>
  <div>
    <Topnav />
    <div class="content">
      <div class="jumbotron text-center">
        <h2>User Guide</h2>
        <hr class="bg-dark"/>
        <p>Bot Creator helps you to create and host Telegram chatbots with zero coding skills and can save a lot of your time and effort.</p>
        
      </div>
      <div class="container mb-5">
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-xs-12 col-md-8">
            <div class="mb-5">
              <p>
                Telegram chatbot is a great way to automate the interaction with your potential customers.
                By creating a chatbot with Bot Creator, you can achieve more than a normal chatbot does.
              </p>

              <p>
                <router-link
                  to="/templates"
                  class="text-info"
                >Here are some of the use cases on this page</router-link>
              </p>

              <p>
                Creating chatbots with Bot Creator is very simple, Use our easy to use GUI editor to configure your bots,
                your bot can be online in just a few minutes.
              </p>

              <p>
                Before you can create the bot, you need to get the bot token from the Telegram, You can get your bot token from @botfather. BotFather is a Telegram's official bot to create the bots.
                <a
                  href="https://t.me/botfather"
                  target="_blank"
                >To chat with BotFather click here</a> or go to Telegram app and search for @botfather.
                Start the bot and send "/newbot" and follow the instructions, in the end, you will get your bot token, copy and keep it ready.
              </p>

              <p>
                This is a simple user guide about our editor. This section will cover every feature available
                and how to use them.
              </p>

              <p>Bot editor has 2 major sections, Triggers and Chats.</p>
            </div>

            <div class="mb-5">
              <h4>Triggers</h4>
              <p>
                A trigger is an action from a user.
                The bot can be triggered in following ways to start a chat with it.
              </p>
              <ol>
                <li>Commands</li>
                <li>Reply Buttons</li>
                <li>Inline Buttons</li>
                <li>Keywords</li>
                <li>Schedules</li>
              </ol>
            </div>

            <div class="mb-5" id="Commands">
              <h4>Commands</h4>
              <p>
                Commands are a quick way to start a chat with the bot, commands normally start with "/" followed by a command name.
                Every new user starts a chat with the bot by giving "/start" command.
                So it is necessary to create "/start" command for every bot. You can create as many commands as you need.
                You can customise the command as an admin command, such command will not be visible to the public and those commands can only be invoked by bot admins.
              </p>
              <div class="row mb-3">
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                  <img
                    src="https://core.telegram.org/file/811140845/2/rNUxpcGDeQU/05eaaf20b0dbaf9cb3"
                    alt="commands"
                    class="img-fluid"
                  />
                </div>
                <div class="col-lg-4"></div>
              </div>
            </div>

            <div class="mb-5" id="ReplyButton">
              <h4>Reply Button</h4>
              <p>
                Reply Buttons are a great way to receive predefined input from users.
                You can allow the users to quickly select the one of the populated option.
              </p>
              <p>
                Whenever your bot sends a message, it can pass along a special keyboard with predefined reply options. Telegram apps that receive the message will display your keyboard to the user. Tapping any of the buttons will immediately send the
                respective message. This way you can drastically simplify user interaction with your bot.
              </p>
              <div class="row mb-3">
                <div class="col-lg-4 mb-3">
                  <img
                    src="https://core.telegram.org/file/811140184/1/5YJxx-rostA/ad3f74094485fb97bd"
                    alt="reply button"
                    class="img-fluid"
                  />
                </div>
                <div class="col-lg-4 mb-3">
                  <img
                    src="https://core.telegram.org/file/811140880/1/jS-YSVkDCNQ/b397dfcefc6da0dc70"
                    alt="reply button"
                    class="img-fluid"
                  />
                </div>
                <div class="col-lg-4 mb-3">
                  <img
                    src="https://core.telegram.org/file/811140733/2/KoysqJKQ_kI/a1ee46a377796c3961"
                    alt="reply button"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>

            <div class="mb-5" id="InlineButton">
              <h4>Inline Button</h4>
              <p>
                There are times when you'd prefer to do things without sending any messages to the chat. For example, when your user is changing settings or flipping through search results. In such cases you can use Inline Buttons that are integrated
                directly into the messages they belong to.
              </p>
              <p>Unlike with custom reply keyboards, pressing buttons on Inline Buttons doesn't result in messages sent to the chat</p>
              <p>There are 3 types of Inline buttons.</p>
              <h5>Inline Callback button</h5>
              <p>
                When a user presses a callback button, no messages are sent to the chat. Instead, your bot simply receives the relevant query. Upon receiving the query, your bot can display some result in a notification at the top of the chat screen or
                in
                an alert. You can send notification or alert using "AnswerCallbackQuery" method
              </p>
              <div class="row mb-3">
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                  <img
                    src="https://core.telegram.org/file/811140423/1/6BVlO7dWPeo/64d0d842ff73ff3dc8"
                    alt="callback button"
                    class="img-fluid"
                  />
                </div>
                <div class="col-lg-4"></div>
              </div>
              <h5>Inline URL button</h5>
              <p>Buttons of this type have a small arrow icon to help the user understand that tapping on a URL button will open an external link. Naturally, Telegram will show them a confirmation alert before opening the link in the browser.</p>
              <div class="row mb-3">
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                  <img
                    src="https://core.telegram.org/file/811140999/1/2JSoUVlWKa0/4fad2e2743dc8eda04"
                    alt="url button"
                    class="img-fluid"
                  />
                </div>
                <div class="col-lg-4"></div>
              </div>
              <h5>Inline Login Button</h5>
              <p>
                Login button helps you to log in the Telegram users directly to your website. But before sending this you need to link your website login URL to your bot with @botfather and you need to handle login function in your website.
                Read more about
                <a
                  href="https://core.telegram.org/widgets/login"
                  target="_blank"
                >Telegram Login Here</a>
              </p>
              <div class="row mb-3">
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                  <img
                    src="https://telegram.org/file/811140015/1734/8VZFkwWXalM.97872/6127fa62d8a0bf2b3c"
                    alt="url button"
                    class="img-fluid"
                  />
                </div>
                <div class="col-lg-4"></div>
              </div>
              <p>Each Trigger need to be linked with the Chat that need to be invoked.</p>
            </div>

            <div class="mb-5" id="Keywords">
              <h4>Keywords</h4>
              <p>
                You can also mention keywords that a user can use in conversation with the bot. Bot will start the
                specified chat flow if it encounters a keyword in user message.
              </p>
              <p>For example, Let's create a keyword called 'product' and link it to chat flow that shows available
                products. When user sends message as "What are the products available ?" or "Can you show me available products" 
                or "Show products" or any message that contains 'product' keyword then bot will start the chat
                flow that shows the products.
              </p>
            </div>

            <div class="mb-5" id="Schedule">
              <h4>Schedule</h4>
              <p>
                You can schedule your chats to run every minute or every hour or every day based on your use case.
                Use this feature to automate your bot.
              </p>
              <p>For example, If I wanted to post stock market index data to my channel every hour, I can create a chat
                that fetches the market data from stock market data provider API and posts it to my channel. 
                then schedule this chat to run every hour. I can now just sit and watch while the bot does my job.
              </p>

              <p>Follow UTC timezone to specify the timings.</p>
            </div>

            <div class="mb-5" id="Chats">
              <h4>Chat</h4>
              <p>
                Chat or Chat flow is a flow of Actions from bot, For every message from user one Action in the chat flow will be executed.
                Action can contain multiple tasks. task can be a replying to user, sending message to channel/group/user,
                making HTTP request, storing data ... etc.
                Each chat can be linked with one or more Triggers, Chat flow is started whenever the bot receives its corresponding
                trigger from the user such as command, Reply Button, Inline button or Keyword.
                Once the chat flow is started, Bot follows the Actions present in the chat, one Action will be executed for a one message from the user.
              </p>

              <p>An Action can contain multiple task. A task can be created with one of the following methods.</p>

              <Accordian :data="methods"></Accordian>
            </div>

            <div class="mb-5" id="Variables">
              <h4>Variables</h4>
              <p>Variables are used to label the data, It is helpful to think of variables as containers 
                that hold information. Their sole purpose is to label and store data. 
                This data can then be used throughout your bot Chats.</p>
                <p>You can create as many variables as you need.
                  just add double brackets around variable name to use created variables in chats.
                </p>
                <p>Example: Hi user, Visit our offer page to get discounts {{"{{ offer_page_url }"}}} </p>
            </div>
            <div class="mb-5" id="Magic-Variables">
              <h4>Magic Variables</h4>
              <p>Magic variables are nothing but variables but the value of the magic variable is not fixed,
                its value depends on the context and differs from user to user. for example first_name is one of the 
                magic variable and the value of this variable is name of the user chatting with the bot.
              </p>
      
              <p>
                For example, if you want to say "Hello Rob" for a user named Rob and "Hello Jain" for a user named Jain. 
                You can achieve this by simply placing text as "Hello {{"{{ first_name }"}}}". 
                {{"{{first_name}"}}} will be replaced with the user's first name.
              </p>

              <p>You can use the following list of magic variables</p>

              <MagicVariables></MagicVariables>

              <p>Variables that are created in Task CreateVariable and StoreData will also become a magic
                variables. value of these variables depends on the user context.
              </p>
            </div>

            <div class="mb-5" id="referrals">
              <h4>Referrals</h4>
              <p>Referral is the inbuilt feature of the Bot Creator, It automatically tracks the referrals made by the users.
                and sends notification to user for the successful referrals.
              </p>
              <p>Magic variable "referrals" stores the total referrals made by the user to this bot.</p>
              <p>To make a referral user need to generate his referral link and give it to other users. You 
                can generate a referral link by using the magic variable "referral_link".
              </p>
              <p>Creator can see the each user referrals in the subscribers section of the dashboard.</p>

            </div>

            <div class="alert alert-info text-center" @click="toTutorial()">
              <h6>
                <router-link
                  class="nav-link"
                  to="/tutorials"
                >Here are some of the tutorials to start with.</router-link>
              </h6>
            </div>
          </div>
          <div class="col-md-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style media="screen">
p,
li {
  color: #000;
}
</style>

<script type="text/javascript">
import Accordian from "@/components/Accordian.vue";
import Topnav from "@/components/Topnav.vue";
import MagicVariables from "@/components/MagicVariables.vue";

export default {
  name: "UserGuide",
  components: {
    Accordian,
    Topnav,
    MagicVariables
  },
  data: function() {
    return {
      methods: [
        {
          header: "AnswerCallbackQuery",
          content:
            "Use this method to send notification or alert in response to Inline callback button."
        },
        {
          header: "Arithmeticoperation",
          content:
            "Use this method to do mathematical calculations"
        },
        {
          header: "ArrayOperation",
          content:
            "This method helps to do few list operations, like adding element to list or deleting element from list."
        },
        {
          header: "BanChatMember",
          content:
            "Use this method to restrict a user in a supergroup. The bot must be an administrator in the supergroup for this to work and must have the appropriate admin rights."
        },
        {
          header: "Compare",
          content: `Compares two values with available operators, if comparison result is true moves to next task,
          else execute the tasks defined inside this task.`
        },
        {
          header: "CopyMessage",
          content: `Use this method to copy messages of any kind. The method is analogous to the method forwardMessages, but the copied message doesn't have a link to the original message.`
        },
        {
          header: "CreateChatInviteLink",
          content: `Use this method to generate a new invite link for a chat; any previously generated link is revoked. The bot must be an administrator in the chat for this to work and must have the appropriate admin rights.`
        },
        {
          header: "CreateVariable",
          content: `This method helps to create a variable to store data.`
        },
        {
          header: "DeleteMessage",
          content: `Deletes the message sent from the bot. It needs message_id of the message to delete the message.
          this method can be used in response to Inline callback button. A message can only be deleted if it was sent less than 48 hours ago.`
        },
        {
          header: `EditMessageText`,
          content: `Edit the text of the message sent from the bot, usually used with the message having Inline buttons and in response to Inline callback button. A message can only be edited if it was sent less than 48 hours ago.`
        },
        {
          header: `EditMessageCaption`,
          content: `Edit the caption of the message with media sent from the bot, usually used with the message having Inline buttons and in response to Inline callback button. A message can only be edited if it was sent less than 48 hours ago.`
        },
        {
          header: `EditMessageInlineKeyboard`,
          content: `Edit the Inline button of the message sent from the bot, usually used with the message having Inline buttons and in response to Inline callback button. A message can only be edited if it was sent less than 48 hours ago.`
        },
        {
          header: `EditMessageMedia`,
          content: `change the media (photo/video/voice/GIF/document) of the message with media sent from the bot, usually used with the message having Inline Buttons and in response to Inline callback button. New media used to change the old media should be of same type, It means photo should be changed with another photo and video with another video . A message can only be edited if it was sent less than 48 hours ago.`
        },
        {
          header: `ForwardMessage`,
          content: `Forward the incoming message from the user to another user/channel/group.`
        },
        {
          header: `GetChatAdministrators`,
          content: `Use this method to get a list of administrators in a chat.`
        },
        {
          header: `GetChatMembersCount`,
          content: `Use this method to get the number of members in a chat.`
        },
        {
          header: `HttpRequest`,
          content: `A great way to interact with third party apps. Response of the http request made will be stored in "http_result" as a json object`
        },
        {
          header: `IsChatMember`,
          content: `Use this method to check if the user is a member of a channel or super group.`
        },
        {
          header: `KickExpiredPrimeMembers`,
          content: `Use this method to kick expired prime members from the group or channel.`
        },
        {
          header: `LeaderBoard`,
          content: `Use this method to get the top referrals for the group or channel.`
        },
        {
          header: `Reply`,
          content: `Use this method to reply user with the text message.`
        },
        {
          header: `SendAnimation`,
          content: `Use this method to send animation files (GIF or H.264/MPEG-4 AVC video without sound).
          Bots can currently send animation files of up to 50 MB in size, this limit may be changed in the future.`
        },
        {
          header: `SendAudio`,
          content: `Use this method to send audio files, if you want Telegram clients to display them in the music player. Your audio must be in the .MP3 or .M4A format.Bots can currently send audio files of up to 50 MB in size, this limit may be changed in the future.`
        },
        {
          header: `SendContact`,
          content: `Use this method to send phone contacts.`
        },
        {
          header: `SendDocument`,
          content: `Use this method to send general files. Bots can currently send files of any type of up to 50 MB in size, this limit may be changed in the future.`
        },
        {
          header: `SendLocation`,
          content: `Use this method to send point on the map.`
        },
        {
          header: `SendMessage`,
          content: `Use this method to send text messages.`
        },
        {
          header: `SendPhoto`,
          content: `Use this method to send photos.`
        },
        {
          header: `SendPoll`,
          content: `Use this method to send a native poll.`
        },
        {
          header: `SendQuiz`,
          content: `Use this method to send a quiz.`
        },
        {
          header: `SendVenue`,
          content: `Use this method to send information about a venue.`
        },
        {
          header: `SendVideo`,
          content: `Use this method to send video files, Telegram clients support mp4 videos (other formats may be sent as Document). Bots can currently send video files of up to 50 MB in size, this limit may be changed in the future.`
        },
        {
          header: `SendVideoNote`,
          content: `Telegram clients support rounded square mp4 videos of up to 1 minute long. Use this method to send video messages.`
        },
        {
          header: `SendVoice`,
          content: `Use this method to send audio files, if you want Telegram clients to display the file as a playable voice message. For this to work, your audio must be in an .OGG file encoded with OPUS (other formats may be sent as Audio or Document). Bots can currently send voice messages of up to 50 MB in size, this limit may be changed in the future.`
        },
        {
          header: `SetChatPermisssions`, 
          content: `Use this method to set default chat permissions for all members in Groups.`
        },
        {
          header: `StoreData`,
          content: `Use this method to store data specific to users, you can view stored data in Dashboard page of bot.`
        },
        {
          header: 'UnBanChatMember',
          content: `Use this method to unban a previously banned user in a supergroup. The user will not return to the group automatically, but will be able to join via link, etc. The bot must be an administrator for this to work.`
        },
        {
          header: `ValidateInput`,
          content: `Use this method to verify user input message as mobile number, email, URL or number. If the validation is unsuccessful then user will be asked to resend the message with expected value. Use this method while collecting user information such as mobile number or email.`
        }
      ],
    };
  },
  methods: {
    toTutorial: function() {
      this.$router.push({
        path: "/tutorials"
      });
    }
  }
};
</script>
